import React, { useContext, useState } from "react";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import ModalMain from "../../../../components/Modal/ModalMain";
import { ChoiceGroup } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import loaderContext from "../../../../context/loader/LoaderContext";
import toastContext from "../../../../context/toast/ToastContext";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { TOAST_TYPE } from "../../../../constants/Constants";
import { choiceGroupStyles } from "../../../Report/helper/initialData";
import { getPatientDetailsAPI,submitEditPatientDetails } from "../../../../service/StudyListService";
import Moment from "moment";

/** Same emergency options & styles the EditPatientBody uses */
const emergencyOptions = [
  { key: 2, text: "Emergency" },
  { key: 3, text: "Non Medical Emergency" },
];

const fmt = (d) => (d ? Moment(d).local().format("DD-MMM-YYYY") : null);

const SetEmergencyModal = ({ show, onClose, studyId, rowIndex, dataRow, defaultKey = 2, onSubmit }) => {
  const [t] = useTranslation();
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const { setDataQueryState } = useContext(studylistContext);
  const [selected, setSelected] = useState(defaultKey); // default Emergency

  const PrimaryButtonList = [{ title: t("button.submit"), onclick: () => onSubmit(selected)},];
  const DefaultButtonList = [{ title: t("button.cancel"), onclick: onClose }];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        patientName={dataRow.patientName}
        patientID={dataRow.patientId}
        heading={"Set Emergency"}
        handleCancel={onClose}
      />
    ),
    footer: <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} />,
    body: (
      <div className="edit-patient-modal-container">
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row single-line-form-field" style={{ flexDirection: "column", alignItems: "flex-start" }}>
            {/* <div className="ms-Grid-row ms-sm12 ms-lg4 ms-xl6" style={{ marginLeft: "10px", marginTop: "10px" }}>
              <p style={{ fontWeight: 600 }}>Emergency</p>
            </div> */}
            <div className="ms-Grid-row ms-sm12 ms-md8 ms-lg4 ms-xl12" style={{ marginLeft: "10px" }}>
              <ChoiceGroup
                selectedKey={selected}
                options={emergencyOptions}
                onChange={(_, o) => setSelected(o.key)}
                styles={choiceGroupStyles}
              />
            </div>
          </div>
        </div>
      </div>
    ),
    width: "700px",
  };

  return <ModalMain updatedModal={true} showModal={show} modalDetails={modalDetails} />;
};

export default SetEmergencyModal;
